/**
 * 调试模式状态管理 Store。
 */
import { create } from "zustand";

const useDebugStore = create((set, get) => ({
	// Debug states
	isDebugMode: false,
	showDebugInfo: false,
	logLevel: "info", // 'info' | 'warn' | 'error' | 'debug'

	// Actions
	toggleDebugMode: () => set((state) => ({ isDebugMode: !state.isDebugMode })),
	toggleDebugInfo: () =>
		set((state) => ({ showDebugInfo: !state.showDebugInfo })),
	setLogLevel: (level) => set({ logLevel: level }),

	// Debug logging functions
	log: (...args) => {
		if (get().isDebugMode) {
			console.log("[Debug]", ...args);
		}
	},

	warn: (...args) => {
		if (get().isDebugMode && ["warn", "debug"].includes(get().logLevel)) {
			console.warn("[Debug Warning]", ...args);
		}
	},

	error: (...args) => {
		if (get().isDebugMode && ["error", "debug"].includes(get().logLevel)) {
			console.error("[Debug Error]", ...args);
		}
	},

	// Initialize debug commands in console
	initDebugCommands: () => {
		if (typeof window !== "undefined") {
			window._debug = {
				toggle: get().toggleDebugMode,
				showInfo: get().toggleDebugInfo,
				setLogLevel: get().setLogLevel,
				getState: () => ({
					isDebugMode: get().isDebugMode,
					showDebugInfo: get().showDebugInfo,
					logLevel: get().logLevel,
				}),
			};
			console.log(
				"Debug commands initialized. Use window._debug to access debug controls",
			);
		}
	},
}));

export default useDebugStore;
